import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');

class ReservedUnits extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);		
		this.setTable = this.setTable.bind(this);

		var aux_date = new Date();

		this.state = {
			health_facilities_id:"",
			start_date 	: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			end_date 	: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			
			columns:[
				{title:'No. Petición', width:'100px'},
				{title:'Fecha/Hr. Solicitud', width:'150px'},
				{title:'Paciente', width:'250px'},				
				{title:'GR&RH Paciente', width:'150px'},
				{title:'Componente', width:'250px'},
				{title:'Unidad', width:'150px'},
				{title:'GR&RH Unidad', width:'150px'},
				{title:'Estatus', width:'150px'},
				{title:'Muestra', width:'150px'},
				{title:'Fecha/Hr Reserva', width:'150px'},
				{title:'Usuario Reserva', width:'250px'},
				{title:'Fecha/Hr. Retiro Reserva', width:'150px'},
				{title:'Usuario Retiro Reserva', width:'250px'},
				{title:'Turno', width:'150px'},
			],
			filename:"Unidades Reservadas",
			component_type:"all",
			components:[],
			blood_component_id:"all",
			blood_components:[],
			listado:[],
			total:"",
			compatible:"",
			incompatible:"",
			retired:"",
			date_hour:"",
			medical:"",
			work_session: "all",
			sessions: [],
			status:"all",
			status_name:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		
		fetch(Config.default.apiGateway.URL+'lookups?type=blood_component_type&option=actives&order=false', {
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({components:response});
			}
		})

		fetch(Config.default.apiGateway.URL+'work_sessions/actives?health_facilities_id='
			+sessionStorage.getItem('health_facilities_id'), {
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({sessions:response});
			}
		})

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date_hour:aux[0]+' '+hours,
			});
		})

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	getBloodComponent(){
		fetch(Config.default.apiGateway.URL+'blood_component/by_type?type='+this.state.component_type, {
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({blood_components:response});
			}
		})
	}

	setTable(){
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 

		this.$el = $(this.el);
		
		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdf',
					title: this.state.filename,
					orientation:'landscape',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});

                		doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });

						doc.content.splice(3, 0, {
							columns:[
								this.state.status !== "all" && this.state.status !== "" ?
									{text: 'Estatus', width:'10%', fontSize:6.5}
								: {text:"", width:0},
								this.state.status !== "all" && this.state.status !== "" ?
									{text: this.state.status_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},
							]
						});


                		console.log(doc)
						//doc.content[3].table.widths=["6%","8%","5%","18%","6%","9%", "8%","6%","7%","11%","16%"];

						doc.content.push({
							text: 'Total: '+this.state.total+'\t\tCompatibles: '+this.state.compatible+'\t\tIncompatibles: '+this.state.incompatible,
							margin:[10,10,0,0],
							bold:1
						})
						/*this.state.total_comp.map((t, i)=>(
							doc.content.push({
								text: t.text+': '+' '+t.num,
								bold: 1,
								margin: [10,0,0,0]
							})
						))*/

						doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5; 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	}
            ],
			data: this.state.listado,
			columns:this.state.columns,
			columnDefs: [{
		        targets: [0,1,2,4,5,6,7,8,9],
		        className: 'dt-center'
    		}],
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
			
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		var control = document.getElementById(e.target.name);
		
		if(control.required && control.className.includes('error')){
			control.classList.remove('error');
		}

		if(e.target.name === 'component_type'){
			if(e.target.value === 'all'){
				this.setState({blood_component_id:'all'});
			}else{
				this.setState({
					component_name: e.target.options[e.target.selectedIndex].text
				});
				setTimeout(()=>{
					this.getBloodComponent();
				}, 500);
				
			}
		}else if(e.target.name === 'blood_component_id'){
			this.setState({
				blood_component_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'work_session'){
			this.setState({
				work_session_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'status'){
			this.setState({
				status_name: e.target.options[e.target.selectedIndex].text
			})
		}
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				var obj = {
					start_date:this.state.start_date,
					end_date:this.state.end_date,
					component_type:this.state.component_type,
					blood_component_id: this.state.blood_component_id,
					health_facilities_id:sessionStorage.getItem('health_facilities_id'),
					work_sessions_id: this.state.work_session,
					option:this.state.status
				};
				
				this.props.waiting.handleShow('Buscando...');
				fetch(Config.default.apiGateway.URL+'reports/unit_reserved',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.setState({
							listado: [],
						});

						var list = [];
						var group_rh="", unit_group_rh=""
						response.resp.map((r, i)=>{
							group_rh = r.group_rh+((r.lectina !== null && r.lectina !=="")?(" ("+r.lectina+")"):""); 
							unit_group_rh = r.unit_group_rh + ((r.unit_lectina !== null && r.unit_lectina !=="")?(" ("+r.unit_lectina+")"):""); ;
							var obj = [
								r.petition_number,
								moment(r.petition_timestamp).format('DD/MM/YYYY HH:mm'),
								r.patient,
								group_rh,
								r.code,
								r.unit_number,
								unit_group_rh,
								r.status,
								r.samples,
								moment(r.register_date).format('DD/MM/YYYY')+' '+
								moment(r.register_hour, 'HH:mm:ss').format('HH:mm'),
								r.user,
								r.remove_reserved !== null ?
									moment(r.remove_reserved).format('DD/MM/YYYY HH:mm')
								: "",
								r.remove_user,
								r.session
							];

							list.push(obj);						
						});

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);

						this.setState({
							listado: list,
							total:response.tot,
							compatible:response.tot_comp,
							retired:response.tot_removed,
							incompatible: response.tot_incomp
						});
						
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Paciente ->
					Unidades Reservadas
					</h5>
				</div>
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								
								<div className="form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Tipo de Componente</span>
									<select type="text" name="component_type" id="component_type" 
										value={this.state.component_type} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.components.map((h, i)=>{
											return <option key={i} value={h.key}>
												{h.name}
											</option>
										})}
									</select>
								</div>

								{this.state.component_type !== 'all' ?
									<div className="form-group">
										<span className="span-min">Componente</span>
										<select type="text" name="blood_component_id" id="blood_component_id" 
											value={this.state.blood_component_id} onChange={this.handleChange}
											className="form-control" required>
											<option value="">Seleccione...</option>
											<option value="all">TODOS</option>
											{this.state.blood_components.map((h, i)=>{
												return <option key={i} value={h.id}>
													{h.component}
												</option>
											})}
										</select>
									</div>
								: null}

								<div className="form-group">
									<span className="span-min">Turno</span>
									<select type="text" name="work_session" id="work_session" 
										value={this.state.work_session} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.sessions.map((h, i)=>{
											return <option key={i} value={h.id}>
												{h.value}
											</option>
										})}
									</select>
								</div>

								<div className="form-group">
									<span className="span-min">Estatus</span>
									<select type="text" name="status" id="status" 
										value={this.state.status} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										<option value="reserves">RESERVADAS</option>
										<option value="remove_reserved">RESERVAS RETIRADAS</option>
									</select>
								</div>

								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12 form-group" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline"}}>
									<span>
										{this.state.filename}
									</span>
								</div>
								<div className="col-xs-12 form-group" >
									<span>
										Información Del:  {this.state.start_date !== "" ?
											moment(this.state.start_date).format("DD/MM/YYYY")
										: ''}    
									</span>
									<span style={{marginLeft:"5px"}}>	
										Al: {this.state.end_date !== "" ?
											moment(this.state.end_date).format("DD/MM/YYYY")
										: ''}
									</span>
								</div>
									
								<div className="col-xs-12" style={{fontSize:'11px'}}>
									{this.state.status !== 'all' && this.state.status !== ""?
										<span>
											Estatus:  
											<b style={{marginLeft:"5px"}}>{this.state.status_name}</b>
										</span>	
									:null}
								</div>

								<div className="col-xs-12 form-group" id="table-to-pdf">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className={"expenses-discards"} id="table-to-xls" width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>
								<div className="col-xs-12">
									<span>Total: </span><label style={{marginLeft:'5px'}}>{this.state.total}</label>
									<span style={{marginLeft:'8px'}}>Compatibles: </span><label style={{marginLeft:'5px'}}>{this.state.compatible}</label>
									<span style={{marginLeft:'8px'}}>Incompatibles: </span><label style={{marginLeft:'5px'}}>{this.state.incompatible}</label>
									<span style={{marginLeft:'8px'}}>Retiradas: </span><label style={{marginLeft:'5px'}}>{this.state.retired}</label>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (ReservedUnits);